// Export of a list of people as a CSV file that Excel opens as is: UTF-8 with a BOM (accents), « ; » as separator
// (French Excel), every field quoted. Built in the browser from the rows already on screen: a manager exports
// only the people of their pairs, as displayed.
const quote = (value: unknown) => `"${String(value ?? '').replace(/"/g, '""')}"`

export function toCsv(columns: string[], labels: (col: string) => string, rows: Array<Record<string, unknown>>) {
  const lines = [
    columns.map((c) => quote(labels(c))).join(';'),
    ...rows.map((r) => columns.map((c) => quote(r[c])).join(';')),
  ]
  return `\ufeff${lines.join('\r\n')}\r\n`
}

export const slug = (text: string) =>
  text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')

export function downloadCsv(title: string, csv: string, today = new Date()) {
  const date = today.toISOString().slice(0, 10)
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const link = document.createElement('a')
  link.href = url
  link.download = `${slug(title)}-${date}.csv`
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
